import { createContext } from 'react';

/**
 * Tema bağlamı — yalnızca context nesnesi ve tipler.
 *
 * Sağlayıcı (`ThemeProvider.tsx`) ve hook (`useTheme.ts`) ayrı dosyalarda:
 * bir modül hem bileşen hem bileşen-olmayan değer export ettiğinde React Fast
 * Refresh o modülü sıcak değiştiremez ve her düzenlemede tüm uygulama durumu
 * sıfırlanır (`react-refresh/only-export-components`). Aynı ayrım `src/i18n`
 * içinde de var.
 */

/**
 * `system` bir üçüncü tema DEĞİL, "tercih belirtme" durumudur.
 *
 * Ayrı tutulmasının sebebi şu: kullanıcı sabah açık, akşam koyu kullanan bir
 * işletim sistemi ayarına sahip olabilir. `system` seçiliyken uygulama bu
 * değişimi CANLI izler. Eğer yalnızca 'light' | 'dark' saklasaydık, kullanıcının
 * bir kez yaptığı seçim onu sonsuza dek sistem tercihinden koparırdı.
 */
export type ThemePreference = 'system' | 'light' | 'dark';

/** Ekranda gerçekten uygulanan tema — `system` çözümlendikten sonraki hâli. */
export type ResolvedTheme = 'light' | 'dark';

export interface ThemeContextValue {
  preference: ThemePreference;
  resolved: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export const THEME_STORAGE_KEY = 'zee.theme';

export function isThemePreference(value: string): value is ThemePreference {
  return value === 'system' || value === 'light' || value === 'dark';
}
